import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {LOGIN, RESET_PASSWORD} from 'router/routes'
import AuthWrapper from 'components/auth/wrapper'
import FormHeader from 'components/auth/formHeader'
import AlertBar from 'components/shared/alertBar'
import {ALERT_TYPES, INPUT_TYPES} from 'constants'
import Input from 'components/shared/form/input'
import {parseError} from 'utils'
import Button from 'components/shared/buttons'
import {forgotPasswordEmail} from 'services/api/actions'
import {forgotPasswordSchema as validationSchema} from 'utils/validations'
import {toast} from 'react-toastify'

const initialValues = {
  email: '',
}

const ForgotPassword = () => {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState(false)

  const onSubmit = (values, {setStatus}) => {
    setLoading(true)
    forgotPasswordEmail(values.email)
      .then(() => {
        setLoading(false)
        setHasErrors(false)
        setStatus('')
        toast.success('OTP sent to you email. Please check.')
        navigate(RESET_PASSWORD)
      })
      .catch((error) => {
        setLoading(false)
        setHasErrors(true)
        setStatus(parseError(error))
      })
  }

  const {handleSubmit, getFieldProps, touched, errors, status} = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  return (
    <AuthWrapper>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        onSubmit={handleSubmit}
      >
        <FormHeader title='Forgot Password ?' subTitle='Enter your email to reset your password.' />
        <AlertBar message={status} type={hasErrors ? ALERT_TYPES.danger : ALERT_TYPES.success} />

        <div className='fv-row mb-10'>
          <Input
            label='Email'
            placeholder='Email'
            type={INPUT_TYPES.email}
            touched={!!touched.email}
            error={errors.email || ''}
            {...getFieldProps('email')}
          />
        </div>

        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <Button className='fw-bolder me-4' loading={loading} disabled={loading} label='Submit' />

          <Button
            className='fw-bolder'
            type='button'
            styleType='secondary'
            label='Cancel'
            disabled={loading}
            onClick={() => navigate(LOGIN)}
          />
        </div>
      </form>
    </AuthWrapper>
  )
}

export default ForgotPassword
